export const scrollToPosition = (scrollPosition: number) => {
	if (scrollPosition) {
		setTimeout(() => {
			window.scrollTo(0, scrollPosition)
		}, 50)
	}
}
